import { Component, OnInit, Inject } from '@angular/core';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { MdInputModule, MdRadioModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

import { BaseService } from '../../../shared/services/base.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';

import { UserUrl } from '../../../shared/urls/user.url';
import { BaseUrl } from '../../../shared/urls/base.url';
import { Utility } from '../../../common/utility';
import { AppConstants } from '../../../shared/constants/constants';
import { UserType } from '../../../shared/constants/permission';
import { AppMessages } from '../../../shared/constants/messages';
import { UserModel } from '../../../models/user/user.model';
import { ManageUserService } from './manage-user.service';

@Component({
  selector: 'edit-user-popup',
  templateUrl: './edit-user-popup.component.html',
  providers: [ManageUserService]
})
export class EditUserPopupComponent implements OnInit {
  public editUserForm: FormGroup;
  public userModel = new UserModel('', '', '', '', '', '', '', '', '');
  public fromMessage: string = '';
  public isRequiredRegistrationNumber: boolean = false;
  public isEditSuccess = false;
  public titleData = [];
  public roleData = [];

  public emailDomainData = [];

  constructor(private formBuilder: FormBuilder,
    public utility: Utility,
    private manageUserService: ManageUserService,
    public dialogService: DialogService,
    public dialogRef: MdDialogRef<EditUserPopupComponent>,
    @Inject(MD_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {
    this.createForm();
    this.getRoles();
    this.getUserInfo();
  }

  getRoles() {
    this.roleData = [];
    this.manageUserService.getUserRoleList().subscribe(
      (result) => {
        if (result) {
          this.roleData = result.json();
        }
      }
    );
  }

  getUserInfo() {
//    let url = UserUrl.GET_USER_URL;
    this.titleData = [];
    this.manageUserService.getUserInfo(this.data.id).subscribe(
    //this.baseService.getData(url + `/${this.data.id}`).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          data.tittles.forEach(element => {
            this.titleData.push({ id: element.id, name: element.name });
          });
          // binding data
          this.userModel = new UserModel(data.userId, data.title, data.firstName, '', data.sureName, data.email, '', data.registrationNumber, data.roleId);
          this.editUserForm.controls['TitleId'].setValue(this.userModel.TitleId);
          // update require on RegistrationNumber
          const role = this.roleData.filter(r => r.id === data.roleId);
          if (role.length > 0) {
            const roleName = role[0].code;
            if (roleName === UserType.Nurse || roleName === UserType.Practitioner) {
              this.isRequiredRegistrationNumber = true;
              ValidationService.attachRequired(this.editUserForm.controls['RegistrationNumber'], []);
            }
          }
        }
      }
    );
  }

  createForm() {
    this.editUserForm = this.formBuilder.group({
      TitleId: [this.userModel.TitleId.toString() || null],
      FirstName: ['', [Validators.required]],
      SureName: ['', [Validators.required]],
      Email: '',
      RegistrationNumber: [''],
      RoleId: ['', [Validators.required]],
      UserId: this.data.id
    });
  }

  onRoleChange(role) {
    let roleId = this.editUserForm.value.RoleId || role;
    let roleName = this.roleData.filter(r => r.id === roleId)[0].code;
    if (roleName === UserType.Nurse || roleName === UserType.Practitioner) {
      this.isRequiredRegistrationNumber = true;
      ValidationService.attachRequired(this.editUserForm.controls['RegistrationNumber'], []);
    } else {
      this.isRequiredRegistrationNumber = false;
      ValidationService.removeRequired(this.editUserForm.controls['RegistrationNumber'], []);
    }
  }

  onCloseDialog(data = null) {
    if (data) {
      this.dialogRef.close(data);
    } else {
      this.dialogRef.close(this.isEditSuccess);
    }
  }

  onSubmit() {
    if (this.editUserForm.valid) {
        this.manageUserService.updateUserInfo(this.data.id, this.editUserForm.value).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            this.isEditSuccess = true;
            // success then close dialog and open success confirm dialog
            this.dialogService.openSuccessDialog({ message: data.message });
            const info = {
              firstName: this.editUserForm.value.FirstName,
              lastName: this.editUserForm.value.SureName
            };
            this.onCloseDialog(info);
          }
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-user/edit-user-popup.component.ts